import { SeparationType } from "../enums/SeparationType";

export class CurrentState {
  orderId: number;
  number: string;
  currentStateLogId?: number | null;
  currentStatePrescriptionLogId?: number | null;
  isCancelled: boolean;
  isClosed: boolean;
  separationType: SeparationType;
  numberOfRecipes?: number;
  allRecipesApproved?: boolean;
  numberOfNotifications?: number;
  externallyChanged?: boolean;

}